import type { Theme } from "@mui/material"
import { createGlobalNavigationItemTheme } from "./components/GlobalNavigationItem"
import { createCompilationsListItemTheme } from "./components/CompilationsListItem"
import { createArticleListGridTheme } from "./components/ArticleListContainer"
import { createCalcInputButtonTheme } from "./components/CustomButton"
import { CustomThemeCreator } from "../../types"
import { createCustomExternalCatalogWidgetIconTheme } from "./components/CustomExternalCatalogWidgetIcon"
import { createSimpleWidgetCardTheme } from "./components/SimpleWidgetCard"
import { createOfferItemTheme } from "./components/OfferItem"
import { createTabsTheme } from "./components/Tabs"
import { createCustomTextFieldTheme } from "./components/TextField"
import { createSuggestionsPaperTheme } from "./components/SuggestionsPaper"

export const Colors = {
    lightblue: "#5F9AFF",
}
export const createTheme: CustomThemeCreator = (theme: Theme) => ({
    GlobalNavigationItem: createGlobalNavigationItemTheme(theme),
    CompilationsListItem: createCompilationsListItemTheme(theme),
    ArticleListGrid: createArticleListGridTheme(theme),
    CalcInputButton: createCalcInputButtonTheme(theme),
    // BasketButton: createBasketButtonTheme(theme),
    CustomExternalCatalogWidgetIcon: createCustomExternalCatalogWidgetIconTheme(theme),
    SimpleWidgetCard: createSimpleWidgetCardTheme(theme),
    SuggestionsPaper: createSuggestionsPaperTheme(theme),
    OfferItem: createOfferItemTheme(theme),
    Tabs: createTabsTheme(theme),
    CustomTextField: createCustomTextFieldTheme(theme),
})
